import { useEffect } from 'react';
import type { CapacityManagementRootResponse } from 'src/apis/capacity-management/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

const CACHE_KEY = 'capacity-management-root';

export function useOptionalCapacityManagementRoot() {
  const capacityManagement = useAxios(
    (axios, baseConfig) =>
      axios.request<CapacityManagementRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.capacityManagement,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: CACHE_KEY,
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    capacityManagement.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return capacityManagement;
}

export type OptionalCapacityManagementRootRequest = ReturnType<
  typeof useOptionalCapacityManagementRoot
>;

export function useCapacityManagementRoot() {
  const capacityManagementRoot = useAxios(
    (axios, baseConfig) =>
      axios.request<CapacityManagementRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.capacityManagement,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: CACHE_KEY,
    }
  );

  useEffect(() => {
    capacityManagementRoot.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return capacityManagementRoot;
}

export type CapacityManagementRootRequest = ReturnType<
  typeof useCapacityManagementRoot
>;
